import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import { motion } from "framer-motion";

const speakers = [
  {
    name: "Tisha Zelner",
    title:
      "First-Year Experience Librarian / Associate Professor | University of Southern Mississippi Libraries",
    image: "https://lib.usm.edu/assets/images/1a_facstaff/tisha_zelner_2.png",
    bio: "Tisha Zelner is an Associate Professor and First-Year Experience Librarian in the Public Services department at Cook Library, University of Southern Mississippi. Her areas of expertise include academic libraries, library leadership and management, library instruction, reference services, and access services. She has been a dedicated member of the USM Libraries faculty for many years and has received the University of Southern Mississippi Excellence in Librarianship Award. She is active in the American Library Association, Association of College and Research Libraries, and the Mississippi Library Association.",
  },
  {
    name: "Jennifer Brannock",
    title:
      "Curator of Rare Books and Mississippiana / Professor | University of Southern Mississippi Libraries",
    image:
      "https://lib.usm.edu/assets/images/1a_facstaff/jennifer_brannock.png",
    bio: "Jennifer Brannock is Professor and Curator of Rare Books and Mississippiana in Special Collections at McCain Library and Archives, University of Southern Mississippi. She holds an MLS from the University of Kentucky, and her expertise encompasses rare book curation, Mississippiana, genealogy, preservation management, and bibliographic instruction. Before joining USM, she held a Kress Fellowship in Art Librarianship at Yale University's Art & Architecture Library. She serves as a bibliographer for genealogy, Mississippiana, and rare books.",
  },
  {
    name: "Craig Carey",
    title:
      "Associate Professor of English | University of Southern Mississippi, Department of English",
    image:
      "https://www.usm.edu/_resources/digital-measures/faculty-images/craig-carey.jpg",
    bio: "Craig Carey is Associate Professor of English at the University of Southern Mississippi. He holds a B.S. from Syracuse University, an M.A. from the University of Chicago, and a Ph.D. from the University of Iowa. His research and teaching focus on 19th-century American literature, media and literary theory, and game studies. His scholarship has appeared in journals such as American Literature, American Literary History, American Periodicals, and Pedagogy.",
  },
  {
    name: "Hannah Dean",
    title:
      "Mississippi Digital Library Coordinator | University of Southern Mississippi, Mississippi Digital Library",
    image: "https://lib.usm.edu/assets/images/1a_facstaff/hannah_dean.png",
    bio: "Hannah Dean is the Mississippi Digital Library Coordinator at Cook Library, University of Southern Mississippi. She holds a BA in History and an MLIS degree. In her role, Dean oversees MDL's work connecting over 60 partner institutions, including archives, historical societies, museums, and libraries, through a collaborative digital platform dedicated to free, open access to Mississippi's cultural and historical resources.",
  },
  {
    name: "Austin Slade",
    title:
      "Manager of Digitization Lab | University of Southern Mississippi Libraries, Digitization Lab",
    image: "https://lib.usm.edu/assets/images/1a_facstaff/austin_slade.png",
    bio: "Austin Slade is the Manager of the Digitization Lab in the Library Technology department at Cook Library, University of Southern Mississippi. He holds an MLIS degree and brings hands-on expertise in digitizing documents and making materials accessible online. His work supports both the USM Digital Collections and broader efforts under the Mississippi Digital Humanities Hub to assist institutions across the state in preserving and sharing their historical holdings.",
  },
  {
    name: "Abbie Norris-Davidson",
    title:
      "Digital Initiatives Librarian / Assistant Professor | University of Mississippi Libraries",
    image:
      "https://secure22.olemiss.edu/myprofile/ShowProfilePhoto.jsp?hide=1&perno=00047191&t=2_1781009005739",
    bio: "Abbie Norris-Davidson is the Digital Initiatives Librarian and an Assistant Professor at the University of Mississippi Libraries. She holds a B.A. in English from Rhodes College and an M.S. in Information Studies from the University of Texas at Austin. Her primary responsibilities include overseeing eGrove, the University of Mississippi's institutional repository, and envisioning new digital initiatives for the library. She is the creator of Mapping Memphis, a spatial humanities project using funeral home ledger data to visualize early 20th-century African American community life in Memphis, and co-creator of Dear Mr. Meredith, which maps letters sent to James Meredith during the integration of Ole Miss.",
  },
  {
    name: "Adam Clemons",
    title:
      "Assistant Professor of Scholar Support and Data Services | University of Mississippi Libraries",
    image:
      "https://secure22.olemiss.edu/myprofile/ShowProfilePhoto.jsp?hide=1&perno=00047496&t=2_1781008685907",
    bio: "Adam Clemons is an Assistant Professor in the Scholar Support and Data Services department at the University of Mississippi Libraries. His work focuses on digital humanities, geospatial humanities, data visualization, and scholarly communication. He teaches workshops on R, Python, data wrangling, visualization, and mapping using tools such as Tableau and ArcGIS StoryMaps. He is co-creator of Dear Mr. Meredith, a digital humanities project that maps letters sent to James Meredith during his historic 1962 integration of the University of Mississippi.",
  },
  {
    name: "Kayla Stan",
    title:
      "Assistant Professor of Geography | University of Southern Mississippi, Department of Geography",
    image: "https://www.usm.edu/news/2023/_images/kayla-stan.jpeg",
    bio: "Kayla Stan is Assistant Professor of Geography at the University of Southern Mississippi. Her scholarship spans two areas: human-environment interactions, climate resilience, and sustainable development with a focus on tropical dry forests, and geospatial analysis of illicit markets including labor trafficking and illicit massage businesses. She is an Affiliate Faculty Member at USM's Center for Human Trafficking Research and Training and was selected as a finalist in the 2023 ArcGIS StoryMaps Competition.",
  },
  {
    name: "KC New",
    title:
      "Assistant Professor, Interim Director of Research, Instruction & Outreach | Mississippi State University Libraries",
    image:
      "https://www.library.msstate.edu/sites/www.lib.msstate.edu/files/people/photo_med_0.jpg",
    bio: "KC New is an Assistant Professor at Mississippi State University Libraries, currently serving as Interim Director of Research, Instruction & Outreach. Based at Mitchell Memorial Library, KC serves as subject specialist for English, humanities, linguistics, and related fields. In their role, KC supports faculty and students in digital humanities projects, text analysis, and research methods, and has co-authored work on the evolution of academic library services and the library as a 'third place' in higher education.",
  },
  {
    name: "Jose Cruz Martinez",
    title:
      "Assistant Teaching Professor, Computing Sciences and Computer Engineering | University of Southern Mississippi",
    image: "https://www.usm.edu/news/2025/_images/jose-martinez.jpeg",
    bio: "Jose Cruz Martinez is Assistant Professor in the School of Computing Sciences and Computer Engineering at the University of Southern Mississippi. He is the inaugural recipient of the Moorman STEM Endowed Professorship, which supports his mentorship of students in USM's Moorman Jump Scholars STEM program. His areas of expertise span information systems, robotics, and broadening participation in computing. He also serves on USM's Artificial Intelligence Task Force, reflecting his engagement with the ethical and educational dimensions of emerging technologies.",
  },
  {
    name: "Amanda Wade",
    title: "Archivist | Mississippi Armed Forces Museum, Camp Shelby",
    image: "",
    bio: "Amanda Wade serves as the Archivist at the Mississippi Armed Forces Museum, located at Camp Shelby approximately 12 miles south of Hattiesburg. The museum is Mississippi's official military history museum and a member of the Army Museum System, housing more than 17,000 artifacts and 4,500 volumes of military history. In her role, Wade manages and provides access to the museum's archival holdings, which document the service and sacrifices of Mississippi veterans across all military branches from the late 19th century to present day.",
  },
  {
    name: "Tommy Lofton",
    title: "Director | Mississippi Armed Forces Museum, Camp Shelby",
    image: "",
    bio: "Tommy Lofton is the Director of the Mississippi Armed Forces Museum at Camp Shelby. A native Mississippian and graduate of the University of Southern Mississippi, he is widely recognized as an engaging storyteller and expert on Mississippi's military history, which spans from the territory's earliest militia formations through modern conflicts. Under his leadership, the museum has expanded its facilities and programming, including a major renovation of the vehicle park and commemoration efforts for Mississippi soldiers killed in action in Iraq. Lofton has collaborated with institutions such as the National WWII Museum and Mississippi Public Broadcasting.",
  },
  {
    name: "Courtney Luckhardt",
    title:
      "Associate Professor of History | University of Southern Mississippi, Department of History",
    image:
      "https://www.usm.edu/_resources/digital-measures/faculty-images/courtney-luckhardt.jpg",
    bio: "Courtney Luckhardt is Associate Professor of History at the University of Southern Mississippi. She holds a B.A. in History from UCLA and a Ph.D. in Medieval Studies from the University of Notre Dame. Her research focuses on the religious and cultural history of the early Middle Ages, exploring ideas about power, holiness, identity, and mobility during the transformation of the Roman world. She is the author of The Charisma of Distant Places: Travel and Religion in the Early Middle Ages and was named USM's recipient of the Mississippi Humanities Council Teacher of the Year award.",
  },
  {
    name: "C.T. Salazar",
    title:
      "Assistant Professor / Undergraduate Research and Digital Scholarship Librarian | Mississippi University for Women, Fant Memorial Library",
    image:
      "https://www.muw.edu/library/wp-content/uploads/sites/10/2026/05/20260115-_J5A9843-edited-scaled.jpg",
    bio: "C.T. Salazar is Assistant Professor and Undergraduate Research and Digital Scholarship Librarian at Fant Memorial Library, Mississippi University for Women. He earned his MFA in Creative Writing from MUW and his MLIS and Graduate Certificate in Archives and Special Collections from the University of Southern Mississippi. Before returning to MUW, he served as a Research & Instructional Services Librarian at Delta State University and later as its Director of Archives and Museums. His debut poetry collection, Headless John the Baptist Hitchhiking, received a starred review from Library Journal. His current manuscript-in-progress, City of Flowers: a people's history of poetry in Mississippi, 1890–1900, received a 2025 Southern Movement Media Fund grant.",
  },
  {
    name: "A. Ross Walton",
    title:
      "Digital Production and Preservation Specialist | University of Southern Mississippi, Center for Oral History and Cultural Heritage",
    image:
      "https://www.usm.edu/oral-history-cultural-heritage/_images/walton-ross-9153.jpg",
    bio: "Arthur Ross Walton is the Digital Production and Preservation Specialist at the Center for Oral History and Cultural Heritage at the University of Southern Mississippi. Walton wears multiple hats at COHCH, serving as sound engineer, researcher, writer, producer, and occasional narrator. He works with one of the largest oral history collections in the South, over 4,000 interviews, helping make the collection accessible to researchers, journalists, educators, and museums.",
  },
  {
    name: "Julian Rankin",
    title: "Strategic Advisor | Walter Anderson Museum of Art, Ocean Springs",
    image:
      "https://georgia-press-us.imgix.net/authors/julian-rankin.jpg?auto=format&w=300&dpr=2&q=100",
    bio: "Julian Rankin is a writer and museum professional. He serves as Strategic Advisor at the Walter Anderson Museum of Art in Ocean Springs, Mississippi, having previously served as its Executive Director. Before joining WAMA, he was the founding Director of the Center for Art & Public Exchange at the Mississippi Museum of Art in Jackson. He is the author of Catfish Dream: Ed Scott's Fight for his Family Farm and Racial Justice in the Mississippi Delta, a James Beard Foundation Book Award nominee and winner of the 2019 Mississippi Institute of Arts and Letters nonfiction award. His work explores identity, place, and the role of art in community life across the contemporary South.",
  },
];

const getInitials = (name = "") =>
  name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const GuestSpeakers = () => {
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);
  useEffect(() => {
    document.title = "Summer Residency 2026 Guest Speakers - MS Digital Hub";
  }, []);
  return (
    <Box
      sx={{
        px: { xs: 2, md: 5 },
        py: { xs: 4, md: 6 },
        backgroundColor: "#fff",
      }}
    >
      {" "}
      <Box sx={{ textAlign: "center", mb: 5 }}>
        {" "}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 500,
            color: "#111827",
            display: "inline-block",
            borderBottom: "2px solid #FFD700",
            pb: 1,
          }}
        >
          Guest Speakers{" "}
        </Typography>{" "}
        <Typography
          sx={{
            mt: 2,
            maxWidth: 720,
            mx: "auto",
            color: "#64748b",
            lineHeight: 1.7,
          }}
        >
          Meet the visiting speakers, librarians, faculty, and cultural heritage
          professionals contributing to the Summer Residency.{" "}
        </Typography>{" "}
      </Box>{" "}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
          },
          gap: 3,
        }}
      >
        {" "}
        {speakers.map((speaker, index) => (
          <motion.div
            key={speaker.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: Math.min(index * 0.03, 0.2) }}
          >
            {" "}
            <Card
              elevation={0}
              sx={{
                height: "100%",
                borderRadius: 4,
                border: "1px solid #e5e7eb",
                overflow: "hidden",
                transition: "all 0.2s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 18px 34px rgba(15, 23, 42, 0.12)",
                },
              }}
            >
              {" "}
              {speaker.image ? (
                <CardMedia
                  component="img"
                  image={speaker.image}
                  alt={speaker.name}
                  sx={{
                    height: 260,
                    objectFit: "contain",
                    objectPosition: "center",
                    backgroundColor: "#f8fafc",
                    p: 2,
                  }}
                />
              ) : (
                <Box
                  sx={{
                    height: 230,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:
                      "linear-gradient(135deg, #fff7cc 0%, #f8fafc 100%)",
                  }}
                >
                  {" "}
                  <Box
                    sx={{
                      width: 110,
                      height: 110,
                      borderRadius: "50%",
                      backgroundColor: "#FFD700",
                      color: "#111827",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "2rem",
                      fontWeight: 900,
                    }}
                  >
                    {getInitials(speaker.name)}{" "}
                  </Box>{" "}
                </Box>
              )}{" "}
              <CardContent sx={{ p: 3 }}>
                {" "}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 800,
                    color: "#111827",
                    lineHeight: 1.2,
                  }}
                >
                  {speaker.name}{" "}
                </Typography>{" "}
                <Typography
                  sx={{
                    mt: 1,
                    color: "#64748b",
                    fontSize: "0.9rem",
                    lineHeight: 1.55,
                  }}
                >
                  {speaker.title}{" "}
                </Typography>{" "}
                <Typography
                  sx={{
                    mt: 2,
                    color: "#475569",
                    fontSize: "0.92rem",
                    lineHeight: 1.7,
                    display: "-webkit-box",
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {speaker.bio}{" "}
                </Typography>{" "}
                <Button
                  onClick={() => setSelectedSpeaker(speaker)}
                  sx={{
                    mt: 2,
                    textTransform: "none",
                    fontWeight: 800,
                    color: "#111827",
                    borderBottom: "2px solid #FFD700",
                    borderRadius: 0,
                    px: 0,
                    "&:hover": {
                      backgroundColor: "transparent",
                      color: "#6b4f00",
                    },
                  }}
                >
                  Read full bio{" "}
                </Button>{" "}
              </CardContent>{" "}
            </Card>{" "}
          </motion.div>
        ))}{" "}
      </Box>{" "}
      <Dialog
        open={Boolean(selectedSpeaker)}
        onClose={() => setSelectedSpeaker(null)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: { xs: 0, sm: 4 },
            overflow: "hidden",
          },
        }}
      >
        {" "}
        {selectedSpeaker && (
          <DialogContent sx={{ p: 0, position: "relative" }}>
            {" "}
            <IconButton
              onClick={() => setSelectedSpeaker(null)}
              sx={{
                position: "absolute",
                top: 14,
                right: 14,
                zIndex: 2,
                backgroundColor: "#fff",
                boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
                "&:hover": { backgroundColor: "#f8fafc" },
              }}
            >
              <CloseIcon />{" "}
            </IconButton>{" "}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "300px 1fr" },
                minHeight: 420,
              }}
            >
              {" "}
              {selectedSpeaker.image ? (
                <Box
                  component="img"
                  src={selectedSpeaker.image}
                  alt={selectedSpeaker.name}
                  sx={{
                    width: "100%",
                    height: { xs: 320, md: "100%" },
                    objectFit: "contain",
                    objectPosition: "center",
                    backgroundColor: "#f8fafc",
                    p: 2,
                  }}
                />
              ) : (
                <Box
                  sx={{
                    minHeight: { xs: 260, md: "100%" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:
                      "linear-gradient(135deg, #fff7cc 0%, #f8fafc 100%)",
                  }}
                >
                  {" "}
                  <Box
                    sx={{
                      width: 120,
                      height: 120,
                      borderRadius: "50%",
                      backgroundColor: "#FFD700",
                      color: "#111827",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "2rem",
                      fontWeight: 900,
                    }}
                  >
                    {getInitials(selectedSpeaker.name)}{" "}
                  </Box>{" "}
                </Box>
              )}{" "}
              <Box sx={{ p: { xs: 3, md: 4 } }}>
                {" "}
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 900,
                    color: "#111827",
                    lineHeight: 1.15,
                  }}
                >
                  {selectedSpeaker.name}{" "}
                </Typography>{" "}
                <Typography
                  sx={{
                    mt: 1.5,
                    color: "#64748b",
                    lineHeight: 1.6,
                    fontWeight: 600,
                  }}
                >
                  {selectedSpeaker.title}{" "}
                </Typography>{" "}
                <Typography
                  sx={{
                    mt: 3,
                    color: "#334155",
                    lineHeight: 1.85,
                    fontSize: "1rem",
                    textAlign: "justify",
                  }}
                >
                  {selectedSpeaker.bio}{" "}
                </Typography>{" "}
              </Box>{" "}
            </Box>{" "}
          </DialogContent>
        )}{" "}
      </Dialog>{" "}
    </Box>
  );
};

export default GuestSpeakers;
